export default __webpack_public_path__ + "static/media/logoMini.3d7b4f54.svg";